import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import { Button, Card, Dialog, Grid, Divider } from "@mui/material";
import Signifier from "../../App/Components/Signifier/Signifier";
import { useSelector } from "react-redux";
import { selectCareersClientValue } from "../../App/State/Slices/SelectedCareersClientSlice";
import Breadcrumb from "../../App/Components/Navigation/Breadcrumbs/Breadcrumbs";
import { getCustomRadius } from "./CustomRadiusService";
import EditCollectionModal from "./Components/EditCollectionModal";
import { LocationOn } from "@mui/icons-material";

function CustomRadiusPage() {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "30%",
      [theme.breakpoints.down("md")]: {
        width: "100%",
        paddingBottom: "100px",
      },
    },
    hint: {
      position: "absolute",
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      marginTop: "auto",
      marginBottom: "auto",
      marginLeft: "auto",
      marginRight: "auto",
      width: "300px",
      height: "300px",
      fontSize: "32px",
      textAlign: "center",
      color: "rgba(0,0,0,.6)",
    },
    card: {
      display: "flex",
      justifyContent: "space-around",
      alignItems: "center",
      padding: "8px",
    },
    icon: {
      fontSize: "35px",
    },
    divider: {
      background: theme.palette.primary.main,
    },
    text: {
      whiteSpace: "nowrap",
      color: theme.palette.primary.copy,
    },
    container: {
      backgroundColor: "rgba(0,0,0,.1)",
      borderRadius: "10px",
      padding: "15px",
      overflowY: "scroll",
    },
  }));

  const classes = useStyles();

  const selectCareersClient = useSelector(selectCareersClientValue);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [showSignifier, setShowSignifier] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [showError, setShowError] = useState(false);

  const columns = [{ label: "Radius", propName: "value" }];

  useEffect(() => {
    if (selectCareersClient !== null) {
      setLoading(true);
      getCustomRadius(selectCareersClient.id).then((response) => {
        setTableData(response);
        setLoading(false);
      });
    }
  }, [selectCareersClient]);

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message={responseMessage}
        error={showError}
      />
      <div className="page-container">
        <Breadcrumb />
        <h1 className="page-title">
          {selectCareersClient.shortName} Custom Radius Collection
        </h1>
        <div className={classes.root}>
          {selectCareersClient === null ? (
            <div className={classes.hint}>
              <span>Select a client</span>
            </div>
          ) : (
            <>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12}>
                  <Button
                    style={{ marginTop: "20px", marginBottom: "20px" }}
                    type="submit"
                    variant="contained"
                    color="primary"
                    onClick={() => setOpenEditModal(!openEditModal)}
                  >
                    Edit Collection
                  </Button>
                </Grid>
              </Grid>
              <Grid container spacing={1} className={classes.container}>
                {tableData.map((item, i) => (
                  <Grid item xs={12} sm={3}>
                    <Card className={classes.card}>
                      <LocationOn className={classes.icon} color="primary" />
                      <Divider
                        orientation="vertical"
                        flexItem
                        className={classes.divider}
                      />
                      <span className={classes.text}>
                        <strong>{item.value}</strong> Miles
                      </span>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </>
          )}
        </div>
        <Dialog open={openEditModal} onClose={() => setOpenEditModal(false)}>
          <EditCollectionModal
            openModal={setOpenEditModal}
            baseClient={selectCareersClient}
            setShowSignifier={setShowSignifier}
            setResponseMessage={setResponseMessage}
            setShowError={setShowError}
            setTableData={setTableData}
            tableData={tableData}
          />
        </Dialog>
      </div>
    </>
  );
}

export default CustomRadiusPage;
